<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-if="$route.query.status == 0" :to="{ path: 'ProcessRawMaterials' }">生产原料信息
                </el-breadcrumb-item>
                <el-breadcrumb-item v-if="$route.query.status == 1" :to="{ path: 'ProcessMidProducts' }">中间产品
                </el-breadcrumb-item>
                <el-breadcrumb-item v-if="$route.query.status == 2" :to="{ path: 'ProcessEndProducts' }">最终产品
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px" size="small"
                     style="width: 60%; margin: auto;margin-top: 15px">
                <el-form-item label="统一编码" prop="number">
                    <el-input v-model="ruleForm.number" placeholder="统一编码"/>
                </el-form-item>
                <el-form-item label="品名" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="品名"/>
                </el-form-item>
                <el-form-item label="CAS号">
                    <el-input v-model="ruleForm.casNo" placeholder="CAS号"/>
                </el-form-item>
                <el-form-item label="是否为危化品" prop="dangerousChemical">
                    <el-radio-group v-model="ruleForm.dangerousChemical" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="危险化学品目录序号">
                    <el-input v-model="ruleForm.directoryNumber" placeholder="危险化学品目录序号"/>
                </el-form-item>
                <el-form-item label="危化品类别" prop="dangerousChemicalType">
                    <el-input v-model="ruleForm.dangerousChemicalType" placeholder="危化品类别"/>
                </el-form-item>
                <el-form-item label="物质形态" prop="form">
                    <el-select v-model="ruleForm.form" style="width: 100%">
                        <el-option v-for="item in formList" :key="item.id" :value="item.id" :label="item.name"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="年消耗量" prop="consumptionForYear">
                    <el-input v-model="ruleForm.consumptionForYear" type="number" placeholder="年消耗量"/>
                </el-form-item>
                <el-form-item label="最大储存量" prop="maxStorageVolume">
                    <el-input v-model="ruleForm.maxStorageVolume" type="number" placeholder="最大储存量"/>
                </el-form-item>
                <el-form-item label="实际储量" prop="practicalStorageVolume">
                    <el-input v-model="ruleForm.practicalStorageVolume" type="number" placeholder="实际储量"/>
                </el-form-item>
                <el-form-item label="存储位置" prop="storageLocation">
                    <el-input v-model="ruleForm.storageLocation" placeholder="存储位置"/>
                </el-form-item>
                <el-form-item label="存储方式" prop="storageMethod">
                    <el-input v-model="ruleForm.storageMethod" placeholder="存储方式"/>
                </el-form-item>
                <el-form-item label="所属重大危险源单元名称">
                    <el-input v-model="ruleForm.belongMajorHazard"/>
                </el-form-item>
                <el-form-item label="所在工艺流程">
                    <el-input v-model="ruleForm.belongTechnologicalProcess" placeholder="所在工艺流程"/>
                </el-form-item>
                <el-form-item v-if="$route.query.status == 1 || $route.query.status == 2"
                              label="是否属于重点监管危险化工工艺" prop="isSuperviseTechnologicalProcess">
                    <el-radio-group v-model="ruleForm.isSuperviseTechnologicalProcess" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="this.$route.query.status == 1 || this.$route.query.status == 2"
                              label="重点监管危险化工工艺名称" prop="superviseTechnologicalProcessName">
                    <el-input v-model="ruleForm.superviseTechnologicalProcessName"/>
                </el-form-item>
                <el-form-item label="是否剧毒化学品" prop="toxicChemicals">
                    <el-radio-group v-model="ruleForm.toxicChemicals" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否重点监管危险化学品" prop="superviseToxicChemicals">
                    <el-radio-group v-model="ruleForm.superviseToxicChemicals" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否特别管控危险化学品" prop="emphasisToxicChemicals">
                    <el-radio-group v-model="ruleForm.emphasisToxicChemicals" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="安全措施" prop="safetyPrecautions">
                    <el-input v-model="ruleForm.safetyPrecautions" placeholder="安全措施"/>
                </el-form-item>
                <el-form-item label="应急处置措施" prop="emergencyMeasure">
                    <el-input v-model="ruleForm.emergencyMeasure" placeholder="应急处置措施"/>
                </el-form-item>
                <el-form-item label="是否易制毒" prop="easyForProducingDrugs">
                    <el-radio-group v-model="ruleForm.easyForProducingDrugs" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否易制爆" prop="easyForExplosiveMaterials">
                    <el-radio-group v-model="ruleForm.easyForExplosiveMaterials" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="" style="margin-top: 40px">
                    <el-button type="primary" style="width: 100%" @click="submit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {rawMaterialAdd, rawMaterialEdit} from '@/api/processManager'

    export default {
        name: 'AddRawMaterials',
        data() {
            return {
                ruleForm: {
                    dangerousChemical: 0,
                    toxicChemicals: 0,
                    superviseToxicChemicals: 0,
                    emphasisToxicChemicals: 0,
                    easyForProducingDrugs: 0,
                    easyForExplosiveMaterials: 0,
                    isSuperviseTechnologicalProcess: 0
                },
                rules: {
                    number: [{required: true, message: '请输入'}],
                    name: [{required: true, message: '请输入'}],
                    dangerousChemical: [{required: true, message: '请输入'}],
                    dangerousChemicalType: [{required: true, message: '请输入'}],
                    form: [{required: true, message: '请选择'}],
                    consumptionForYear: [{required: true, message: '请输入'}],
                    maxStorageVolume: [{required: true, message: '请输入'}],
                    practicalStorageVolume: [{required: true, message: '请输入'}],
                    storageLocation: [{required: true, message: '请输入'}],
                    storageMethod: [{required: true, message: '请输入'}],
                    belongMajorHazard: [{required: true, message: '请输入'}],
                    belongTechnologicalProcess: [{required: true, message: '请输入'}],
                    toxicChemicals: [{required: true, message: '请输入'}],
                    superviseToxicChemicals: [{required: true, message: '请输入'}],
                    emphasisToxicChemicals: [{required: true, message: '请输入'}],
                    safetyPrecautions: [{required: true, message: '请输入'}],
                    emergencyMeasure: [{required: true, message: '请输入'}],
                    easyForProducingDrugs: [{required: true, message: '请输入'}],
                    easyForExplosiveMaterials: [{required: true, message: '请输入'}],
                    isSuperviseTechnologicalProcess: [{required: true, message: '请选择'}],
                    superviseTechnologicalProcessName: [{required: true, message: '请选择'}]
                },
                formList: [
                    {id: 1, name: '固态'},
                    {id: 2, name: '液态'},
                    {id: 3, name: '气态'},
                    {id: 4, name: '等离子态'}
                ]
            }
        },
        created() {
            if (this.$route.params.key) {
                let obj = {...this.$route.params.key}
                delete obj.gmtCreate
                this.ruleForm = {...obj}
            }
        },
        methods: {
            submit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        // 编辑
                        if (this.$route.params.key) {
                            rawMaterialEdit({...this.ruleForm, type: this.$route.query.status}).then(res => {
                                this.$message.success('保存成功')
                                if (this.$route.query.status === 0) {
                                    this.$router.push('ProcessRawMaterials')
                                }
                                if (this.$route.query.status === 1) {
                                    this.$router.push('ProcessMidProducts')
                                }
                                if (this.$route.query.status === 2) {
                                    this.$router.push('ProcessEndProducts')
                                }
                            })
                        }
                        // 新增
                        else {
                            rawMaterialAdd({...this.ruleForm, type: this.$route.query.status}).then(res => {
                                this.$message.success('保存成功')
                                if (this.$route.query.status === 0) {
                                    this.$router.push('ProcessRawMaterials')
                                }
                                if (this.$route.query.status === 1) {
                                    this.$router.push('ProcessMidProducts')
                                }
                                if (this.$route.query.status === 2) {
                                    this.$router.push('ProcessEndProducts')
                                }
                              this.$router.push('ProcessEndProducts')
                            })
                        }
                    } else {
                        return false;
                    }
                });
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    }
</script>

<style scoped>

</style>
